import React from "react";
import { delta } from "../gaCompare";

// mode "pct" shows relative change; mode "points" shows the difference of two ratios in
// percentage points (engagement, bounce). invert makes a decrease the good direction.
export default function DeltaBadge({ current, previous, mode = "pct", invert = false }) {
  if (current == null || previous == null) return <span className="text-[12px] text-slate-400">—</span>;
  const { change, pct, isNew } = delta(current, previous);

  if (isNew) return <span className="text-[12px] font-medium text-emerald-600">new</span>;

  const value = mode === "points" ? change * 100 : pct;
  if (value == null) return <span className="text-[12px] text-slate-400">—</span>;
  if (Math.abs(value) < (mode === "points" ? 0.05 : 0.0005)) {
    return <span className="text-[12px] font-medium text-slate-500">0%</span>;
  }

  const up = value > 0;
  const good = invert ? !up : up;
  const text = mode === "points" ? `${Math.abs(value).toFixed(1)} pt` : `${(Math.abs(value) * 100).toFixed(1)}%`;
  return (
    <span className={`text-[12px] font-medium whitespace-nowrap ${good ? "text-emerald-600" : "text-red-600"}`}>
      {up ? "▲" : "▼"} {text}
    </span>
  );
}
